import { post, queryActivityCategory } from "@/utils/utils";

const activity = {
  state: {
    getActivityInfos: {},
    activityListDetails: {},
    activityCategoryList: [],
    subscribeActivityList: {
      records: []
    },
    allSubscribeActivityList: {
      records: []
    },
    onlineMallstoreList: [],
    offlineCategoryList: [],
    offlineBrandList: [],
    offlineGoodsListResult: [],
    crossQueryResult: [],
    goodsByBarcode: [],
    submitFullDiscountCode: "",
    activityList: [],
    allActivityList: [],
    checkActivityRecordList: [],
    activeListCount: {
      all: 0,
      alnotStartedl: 0,
      running: 0,
      end: 0
    },
    checkActivityRecordListCount: {
      auditPass: "",
      inAudit: "",
      reject: "",
      waitAudit: ""
    },
    allCheckActivityRecordList: [],
    fullDiscountDetails: {
      basicConfigInfo: {},
      dateConfigInfo: {},
      dateConfigRange: {},
      fullDiscountRule: [],
      pasCalendars: [],
      pasGoods: [],
      pasLabels: [],
      pasOutlets: []
    },
    fullReductionDetails: {
      basicConfigInfo: {},
      dateConfigInfo: {},
      dateConfigRange: {},
      fullDiscountRule: [],
      pasCalendars: [],
      pasGoods: [],
      pasLabels: [],
      pasOutlets: []
    },
    fullDeliveruDetails: {
      basicConfigInfo: {},
      dateConfigInfo: {},
      dateConfigRange: {},
      fullDiscountRule: [],
      pasCalendars: [],
      pasGoods: [],
      pasLabels: [],
      pasOutlets: []
    },
    fullDeliveruDetailsOverlay: {
      basicConfigInfo: {},
      dateConfigInfo: {},
      dateConfigRange: {},
      fullDeliveryOverlayRuleModel: {
        overlayRuleModelList: []
      },
      // fullDiscountRule: [],
      pasCalendars: [],
      pasGoods: [],
      pasLabels: [],
      pasOutlets: []
    },
    fullIncreasePurchaseDetails: {
      basicConfigInfo: {},
      dateConfigInfo: {},
      dateConfigRange: {},
      fullDiscountRule: [],
      pasCalendars: [],
      pasGoods: [],
      pasLabels: [],
      pasOutlets: []
    },
    combinationDetails: {
      basicConfigInfo: {},
      dateConfigInfo: {},
      dateConfigRange: {},
      fullDiscountRule: [],
      pasCalendars: [],
      pasGoods: [],
      pasLabels: [],
      pasOutlets: []
    },
    specialRuleDetails: {
      basicConfigInfo: {},
      dateConfigInfo: {},
      dateConfigRange: {},
      fullDiscountRule: [],
      pasCalendars: [],
      pasGoods: [],
      pasLabels: [],
      pasOutlets: []
    },
    goodsIsUsedList: [],
    selectType: "",
    overlayType: "",
    cashierConfig: {
      smgHandOver: false,
      smgPayType: []
    },
    subscribeActiveListCount: {
      all: 0,
      notStart: 0,
      running: 0,
      end: 0
    },
    addReservationCode: "",
    addSubCouponLog: [],
    editSubCouponLogCode: "",
    deleteSubCouponLogCode: "",
    couponPackage: [],
    sendCouponPackageCode: "",
    sendCoupon: {
      records: [],
      total: 0
    },
    allSendCouponList: [],
    subscribeActList: [],
    allSubscribeActList: {},
    subscrobeActListCount: {
      allNum: 0,
      appliedNum: 0,
      canceledNum: 0,
      completedNum: 0
    },
    chargeOffFromIdData: "",
    chargeOffFromCodeData: "",
    chargeList: []
  },
  mutations: {
    CHARGE_OFF_FROM_ID(state, data) {
      state.chargeOffFromIdData = data.result;
    },
    CHARGE_OFF_FROM_CODE(state, data) {
      state.chargeOffFromCodeData = data.result;
    },
    SUBSCRIBE_ACT_LIST(state, data) {
      state.subscribeActList = data.result.applyList;
      state.subscrobeActListCount = {
        allNum: data.result.allNum,
        appliedNum: data.result.appliedNum,
        canceledNum: data.result.canceledNum,
        completedNum: data.result.completedNum
      };
    },
    ALL_SUBSCRIBE_ACT_LIST(state, data) {
      state.allSubscribeActList = data.result.applyList;
    },
    ADD_RESERVATION_ACTIVITY(state, data) {
      state.addReservationCode = data.result;
    },
    ACTIVITY_CATEGORY_LIST(state, data) {
      state.activityCategoryList = data.result || [];
    },
    SUBSCRIBE_ACTIVITY_LIST(state, data) {
      state.subscribeActivityList = data.result.activityList;
      if (state.subscribeActivityList.records) {
        state.subscribeActivityList.records.forEach(v => {
          switch (v.timeStatus) {
            case "running":
              v.timeStatusFormat = "进行中";
              break;
            case "notStart":
              v.timeStatusFormat = "未开始";
              break;
            case "end":
              v.timeStatusFormat = "已结束";
              break;
            default:
              break;
          }
        });
      }
      state.subscribeActiveListCount = {
        all: data.result.all,
        notStart: data.result.notStart,
        running: data.result.running,
        end: data.result.end
      };
    },
    ALL_SUBSCRIBE_ACTIVITY_LIST(state, data) {
      state.allSubscribeActivityList = data.result.activityList;
      if (state.allSubscribeActivityList.records) {
        state.allSubscribeActivityList.records.forEach(v => {
          switch (v.timeStatus) {
            case "running":
              v.timeStatusFormat = "进行中";
              break;
            case "notStart":
              v.timeStatusFormat = "未开始";
              break;
            case "end":
              v.timeStatusFormat = "已结束";
              break;
            default:
              break;
          }
        });
      }
    },
    ONLINE_MALL_STORE_LIST(state, data) {
      state.onlineMallstoreList = data.result;
    },
    CATEGORY_LIST(state, data) {
      state.offlineCategoryList = data.result;
    },
    BRAND_LIST(state, data) {
      state.offlineBrandList = data.result;
      state.offlineBrandList.forEach(v => {
        v.attrValue = v.brandName;
        v.attrId = v.brandId;
        v.createTime = "";
        // v.brandCode === "" || v.brandCode === "-" ? v.brandId : v.brandCode;
        v.attrType = "brand";
        v.tip = "品牌";
      });
    },
    GOODS_LIST_RESULT(state, data) {
      state.offlineGoodsListResult = data.result;
      state.offlineGoodsListResult.forEach(v => {
        v.attrValue = v.goodsName;
        v.attrId = v.goodsSn;
        v.attrType = "goods";
        v.tip = "货号";
      });
    },
    CROSS_QUERY_GOODS(state, data) {
      state.crossQueryResult = data.result;
      state.crossQueryResult.forEach(v => {
        v.attrValue = v.goodsName;
        v.attrId = v.goodsSn;
        v.attrType = "goods";
        v.tip = "货号";
      });
    },
    QUERY_GOODS_BY_BARCODE(state, data) {
      state.goodsByBarcode = data.result;
      state.goodsByBarcode.forEach(v => {
        v.attrValue = v.goodsName;
        v.attrId = v.barcode;
        v.attrType = "barcode";
        v.skuId = v.goodsId;
        v.tip = "条码";
      });
    },
    QUERY_GOODS_BY_BARCODE_PAGE() {},
    SUBMIT_FULL_DISCOUNT(state, data) {
      state.submitFullDiscountCode = data.code;
    },
    SUBMIT_COMBINATION_RULE(state, data) {
      state.submitCombinationRule = data.code;
    },
    EDIT_SUBMIT_COMBINATION_RULE(state, data) {
      state.editSubmitCombinationRule = data.code;
    },
    EDIT_SUBMIT_FULL_DISCOUNT(state, data) {
      state.editSubmitFullDiscountCode = data.code;
    },
    SUBMIT_FULL_REDUCTION(state, data) {
      state.submitFullReductionCode = data.code;
    },
    SUBMIT_INCREASE_RULE(state, data) {
      state.submitIncreaseRuleCode = data.code;
    },
    SUBMIT_SPECIAL_RULE(state, data) {
      state.submitSpecialRuleCode = data.code;
    },
    EDIT_SUBMIT_SPECIAL_RULE(state, data) {
      state.editSubmitSpecialRuleCode = data.code;
    },
    EDIT_SUBMIT_INCREASE_RULE(state, data) {
      state.editSubmitIncreaseRuleCode = data.code;
    },
    EDIT_SUBMIT_FULL_REDUCTION(state, data) {
      state.editSubmitFullReductionCode = data.code;
    },
    SWITCH_AUDIT_STATE(state, data) {
      state.switchAuditState = data.code;
    },
    ACTIVITY_LIST(state, data) {
      state.activityList = data.result.activityList;
      state.activeListCount = {
        all: data.result.all,
        notStarted: data.result.notStarted,
        running: data.result.running,
        end: data.result.end
      };
      if (state.activityList.records) {
        state.activityList.records.forEach(v => {
          v.typeName = queryActivityCategory({
            parentId: v.promotionCode.split("-")[0],
            childId: v.promotionCode.split("-")[1]
          }).childTypeName;
        });
      }
    },
    ALL_ACTIVITY_LIST(state, data) {
      state.allActivityList = data.result.activityList.records;
      if (state.allActivityList.length) {
        state.allActivityList.forEach(v => {
          v.typeName = queryActivityCategory({
            parentId: v.promotionCode.split("-")[0],
            childId: v.promotionCode.split("-")[1]
          }).childTypeName;
          v.activityDateTime = v.startDate + "至" + v.endDate;
          v.outletFormat = v.outlet ? v.outLet.join(",") : "";
          v.labelsFormat = v.labels ? v.labels.join(",") : "";
          switch (v.auditState) {
            case "wait_commit":
              v.auditStateFormat = "待提交";
              break;
            case "wait_audit":
              v.auditStateFormat = "待审核";
              break;
            case "in_audit":
              v.auditStateFormat = "审核中";
              break;
            case "audit_pass":
              v.auditStateFormat = "审核通过";
              break;
            case "reject":
              v.auditStateFormat = "已驳回";
              break;
            default:
              v.auditStateFormat = "";
              break;
          }
          v.enabledStateFormat =
            v.enabledState === "disabled" ? "下线" : "上线";
        });
      }
    },
    DELETE_CURRENT_ACTIVITY(state, data) {
      state.deleteCurrentActivityRowCode = data.code;
    },
    DEL_CURRENT_ACTIVITY(state, data) {
      state.delCurrentActivityRowCode = data.code;
    },
    CHECK_ACTIVITY_RECORD_LIST(state, data) {
      state.checkActivityRecordList = data.result.activityList;
      state.checkActivityRecordList.records.forEach(v => {
        v.typeName = queryActivityCategory({
          parentId: v.promotionCode.split("-")[0],
          childId: v.promotionCode.split("-")[1]
        }).childTypeName;
        v.activityDateTime = v.startDate + "至" + v.endDate;
        v.outletFormat = v.outlet ? v.outLet.join(",") : "";
        v.labelsFormat = v.labels ? v.labels.join(",") : "";
        switch (v.auditState) {
          case "wait_commit":
            v.auditStateFormat = "待提交";
            break;
          case "wait_audit":
            v.auditStateFormat = "待审核";
            break;
          case "in_audit":
            v.auditStateFormat = "审核中";
            break;
          case "audit_pass":
            v.auditStateFormat = "审核通过";
            break;
          case "reject":
            v.auditStateFormat = "已驳回";
            break;
          default:
            v.auditStateFormat = "";
            break;
        }
        v.enabledStateFormat = v.enabledState === "disabled" ? "下线" : "上线";
      });
      state.checkActivityRecordListCount = {
        auditPass: data.result.auditPass,
        inAudit: data.result.inAudit,
        reject: data.result.reject,
        waitAudit: data.result.waitAudit
      };
    },
    ALL_CHECK_ACTIVITY_RECORD_LIST(state, data) {
      state.allCheckActivityRecordList = data.result.activityList.records;
      if (state.allCheckActivityRecordList.length) {
        state.allCheckActivityRecordList.forEach(v => {
          v.typeName = queryActivityCategory({
            parentId: v.promotionCode.split("-")[0],
            childId: v.promotionCode.split("-")[1]
          }).childTypeName;
          v.activityDateTime = v.startDate + "至" + v.endDate;
          v.outletFormat = v.outlet ? v.outLet.join(",") : "";
          v.labelsFormat = v.labels ? v.labels.join(",") : "";
          switch (v.auditState) {
            case "wait_commit":
              v.auditStateFormat = "待提交";
              break;
            case "wait_audit":
              v.auditStateFormat = "待审核";
              break;
            // case "in_audit":
            //   v.auditStateFormat = "审核中";
            //   break;
            case "audit_pass":
              v.auditStateFormat = "审核通过";
              break;
            case "reject":
              v.auditStateFormat = "已驳回";
              break;
            default:
              v.auditStateFormat = "";
              break;
          }
          v.enabledStateFormat =
            v.enabledState === "disabled" ? "下线" : "上线";
        });
      }
    },
    QUERY_FULL_DISCOUNT_DETAILS(state, data) {
      state.fullDiscountDetails = data.result;
    },
    QUERY_ACTIVITY_DETAILS(state, data) {
      state.activityListDetails = data.result;
    },
    QUERY_FULL_REDUCTION_DETAILS(state, data) {
      state.fullReductionDetails = data.result;
    },
    QUERY_COMBINATION_DETAILS(state, data) {
      state.combinationDetails = data.result;
      if (state.combinationDetails.combinationPriceGoods) {
        state.combinationDetails.combinationPriceGoods.forEach(o => {
          o.attrId = o.selectType === "barcode" ? o.barcode : o.goodsSn;
          o.attrType = o.selectType;
          o.attrValue = o.goodsName;
        });
      }
    },
    QUERY_FULL_DELIVERY_DETAILS_OVERLAY(state, data) {
      state.fullDeliveruDetailsOverlay = data.result;
      state.fullDeliveruDetailsOverlay.pasGoods.forEach(o => {
        if (o.attrType === "barcode") {
          o.barcode = o.attrId;
        } else {
          o.goodsSn = o.attrId;
        }
        o.selectType = o.attrType;
        o.goodsName = o.attrValue;
      });
      if (state.fullDeliveruDetailsOverlay.fullDeliveryGoods) {
        state.fullDeliveruDetailsOverlay.fullDeliveryGoods.forEach(o => {
          o.attrId = o.goodsSn;
          o.attrValue = o.goodsName;
        });
      }
      state.selectType = data.result.fullDeliveryOverlayRuleModel.selectType;
      state.overlayType = data.result.fullDeliveryOverlayRuleModel.overlayType;
    },
    QUERY_FULL_DELIVERY_DETAILS(state, data) {
      state.fullDeliveruDetails = data.result;
      state.fullDeliveruDetails.pasGoods.forEach(o => {
        if (o.attrType === "barcode") {
          o.barcode = o.attrId;
        } else {
          o.goodsSn = o.attrId;
        }

        o.selectType = o.attrType;
        o.goodsName = o.attrValue;
      });
      if (state.fullDeliveruDetails.fullDeliveryGoods) {
        state.fullDeliveruDetails.fullDeliveryGoods.forEach(o => {
          o.attrId = o.goodsSn;
          o.attrValue = o.goodsName;
        });
      }

      state.selectType = data.result.fullDeliveryRule.selectType;
    },
    QUERY_SPECIAL_RULE_DETAILS(state, data) {
      state.specialRuleDetails = data.result;
      if (state.specialRuleDetails.listHot) {
        state.specialRuleDetails.listHot.forEach(o => {
          o.attrId = o.selectType === "barcode" ? o.barcode : o.goodsSn;
          o.attrType = o.selectType;
          o.attrValue = o.goodsName;
        });
      }
    },
    QUERY_INCREASE_PURCHASE_DETAILS(state, data) {
      state.fullIncreasePurchaseDetails = data.result;
      state.fullIncreasePurchaseDetails.pasGoods.forEach(o => {
        if (o.attrType === "barcode") {
          o.barcode = o.attrId;
        } else {
          o.goodsSn = o.attrId;
        }

        o.selectType = o.attrType;
        o.goodsName = o.attrValue;
      });
    },
    SUBMIT_FULL_DELIVERY(state, data) {
      state.submitFullDeliveryCode = data.code;
    },
    SUBMIT_FULL_DELIVERY_OVERLAY() {},
    EDIT_SUBMIT_FULL_DELIVERY(state, data) {
      state.editSubmitFullDeliveryCode = data.code;
    },
    EDIT_SUBMIT_FULL_DELIVERY_OVERLAY() {},
    QUERY_GOODS_IS_USED(state, data) {
      state.goodsIsUsedList = data.result;
    },
    QUERY_ATTRIBUTE_TYPE(state, data) {
      state.attributeType = data.result;
    },
    QUERY_ATTRIBUTE_CHILDREN_TYPE(state, data) {
      state.attributeType = data.result;
    },
    SET_CASHIER_CONFIG(state, data) {
      state.setCashierConfigCode = data.result;
    },
    QUERY_CASHIER_CONFIG(state, data) {
      state.cashierConfig = data.result;
    },
    MODIFY_ACTIVITY_INFO_DATA(state, data) {
      state.modifyActivityInfoCode = data.result;
    },
    ADD_SUB_COUPON_LOG(state, data) {
      state.addSubCouponLog = data.result.activityList;
    },
    EDIT_SUB_COUPON_LOG(state, data) {
      state.editSubCouponLogCode = data.code;
    },
    DELETE_SUB_COUPON_LOG(state, data) {
      state.deleteSubCouponLogCode = data.code;
    },
    QUERY_COUPON_PACKAGE(state, data) {
      state.couponPackage = data.result.couponList;
    },
    SAVE_SEND_COUPON_PACKAGE(state, data) {
      state.sendCouponPackageCode = data.code;
    },
    QUERY_SEND_COUPON_LIST(state, data) {
      state.sendCoupon = data.result.subscribeActivityList;
      if (state.sendCoupon.records) {
        state.sendCoupon.records.forEach(v => {
          switch (v.couponType) {
            case "1":
              v.couponTypeFormat = "分享发券";
              v.couponTypeStr = "share";
              break;
            case "2":
              v.couponTypeFormat = "购买发券";
              v.couponTypeStr = "purchase";
              break;
            case "3":
              v.couponTypeFormat = "核销发券";
              v.couponTypeStr = "check";
              break;
          }
        });
      }
    },
    QUERY_ALL_SEND_COUPON_LIST(state, data) {
      state.allSendCouponList = data.result;
    },
    QUERY_CHARGE_LIST(state, data) {
      state.chargeList = data.result;
    },
    ACT_BATCH_OPERATE() {},
    PROMOTION_STAT_INFO_ROI() {},
    TARGET_TREND() {},
    DTORE_ORDER_PROMOTION_GOODS() {},
    ACTIVITY_TREND() {},
    EDIT_ATTR() {},
    QUERY_STORE_CONFIG_ALL() {},
    ADD_STORE_CONFIG_ALL() {},
    EDIT_STORE_CONFIG_ALL() {},
    CREATE_SUPERPOSITION_GIFT() {},
    QUERY_SUPERPOSITION_GIFT() {},
    EDIT_SUPERPOSITION_GIFT() {},
    QUERY_SELECTABLE_RELATION_PROMOTION_LIST() {},
  },
  actions: {
    queryChargeList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeApply/get_charge_list`,
        name: "QUERY_CHARGE_LIST",
        params
      });
    },
    chargeOffFromId({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeApply/do_charge_by_id`,
        name: "CHARGE_OFF_FROM_ID",
        params
      });
    },
    chargeOffFromCode({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/do_charge_by_authCode`,
        name: "CHARGE_OFF_FROM_CODE",
        params
      });
    },
    queryAllSubscribeActList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeApply/sub_apply_list`,
        name: "ALL_SUBSCRIBE_ACT_LIST",
        params
      });
    },
    addReservationActivity({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeActivity/add_activity`,
        name: "ADD_RESERVATION_ACTIVITY",
        params
      });
    },
    setCashierConfig({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/set_smg_config`,
        name: "SET_CASHIER_CONFIG",
        params
      });
    },
    queryCashierConfig({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/show_smg_config`,
        name: "QUERY_CASHIER_CONFIG",
        params
      });
    },
    queryAttributeType({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/get_attribute_type`,
        name: "QUERY_ATTRIBUTE_TYPE",
        params
      });
    },
    queryAttributeChildrenType({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/get_type_value`,
        name: "QUERY_ATTRIBUTE_CHILDREN_TYPE",
        params
      });
    },
    queryGoodsIsUsed({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/get_goods_activity`,
        name: "QUERY_GOODS_IS_USED",
        params
      });
    },
    queryIncreasePurchaseDetails({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/show_increase_purchase`,
        name: "QUERY_INCREASE_PURCHASE_DETAILS",
        params
      });
    },
    queryFullDelivertDetails({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/show_full_delivery`,
        name: "QUERY_FULL_DELIVERY_DETAILS",
        params
      });
    },
    queryFullDelivertDetailsOverlay({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/show_full_delivery/overlay`,
        name: "QUERY_FULL_DELIVERY_DETAILS_OVERLAY",
        params
      });
    },
    editSubmitSpecialRule({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/update_special`,
        name: "EDIT_SUBMIT_SPECIAL_RULE",
        params
      });
    },
    queryFullDiscountDetails({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/show_full_discount`,
        name: "QUERY_FULL_DISCOUNT_DETAILS",
        params
      });
    },
    queryActivityDetails({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeActivity/sub_activity_detail`,
        name: "QUERY_ACTIVITY_DETAILS",
        params
      });
    },
    queryFullReductionDetails({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/show_full_reduction`,
        name: "QUERY_FULL_REDUCTION_DETAILS",
        params
      });
    },
    querySpecialRuleDetails({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/query_special_infoid`,
        name: "QUERY_SPECIAL_RULE_DETAILS",
        params
      });
    },
    queryCombinationDetails({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/show_combination_price`,
        name: "QUERY_COMBINATION_DETAILS",
        params
      });
    },
    querySubscribeActList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeApply/sub_apply_detail`,
        name: "SUBSCRIBE_ACT_LIST",
        params
      });
    },
    queryAllCheckActivityRecordList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/check/check_activity_list`,
        name: "ALL_CHECK_ACTIVITY_RECORD_LIST",
        params
      });
    },
    queryCheckActivityRecordList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/check/check_activity_list`,
        name: "CHECK_ACTIVITY_RECORD_LIST",
        params
      });
    },
    queryActivityList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/check/activity_list`,
        name: "ACTIVITY_LIST",
        params
      });
    },
    deleteCurrentRowActivity({ commit }, params) {
      return post({
        commit,
        url: `/promotion/check/del_activity`,
        name: "DELETE_CURRENT_ACTIVITY",
        params
      });
    },
    delCurrentRowActivity({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeActivity/del_activity`,
        name: "DEL_CURRENT_ACTIVITY",
        params
      });
    },
    queryAllSubscribeActivityList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeActivity/sub_activity_list`,
        name: "ALL_SUBSCRIBE_ACTIVITY_LIST",
        params
      });
    },
    queryAllActivityList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/check/activity_list`,
        name: "ALL_ACTIVITY_LIST",
        params
      });
    },
    switchAuditState({ commit }, params) {
      return post({
        commit,
        url: `/promotion/check/edit_activity`,
        name: "SWITCH_AUDIT_STATE",
        params
      });
    },
    queryActivityCategoryList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/paTypeTreeManager/queryTreestruc`,
        name: "ACTIVITY_CATEGORY_LIST",
        params
      });
    },
    querysubscribeActivityList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeActivity/sub_activity_list`,
        name: "SUBSCRIBE_ACTIVITY_LIST",
        params
      });
    },
    queryOnlineMallStoreList({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/store_outlet_list`,
        name: "ONLINE_MALL_STORE_LIST",
        params
      });
    },
    queryOfflineCategoryList({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/get_category_offline`,
        name: "CATEGORY_LIST",
        params
      });
    },
    queryOfflineBrandList({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/get_brand_offline`,
        name: "BRAND_LIST",
        params
      });
    },
    queryOfflineGoodsListResult({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/get_goods_offline`,
        name: "GOODS_LIST_RESULT",
        params
      });
    },
    queryGoodsByAttribute({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/get_goods_attribute`,
        name: "GOODS_LIST_RESULT",
        params
      });
    },
    crossQueryGoods({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/get_goods_info`,
        name: "CROSS_QUERY_GOODS",
        params
      });
    },
    queryGoodsByBarcode({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/get_goods_info/by_barcode`,
        name: "QUERY_GOODS_BY_BARCODE",
        params
      });
    },
    queryGoodsByBarcodePage({ commit }, params) {
      return post({
        commit,
        url: `/hemiao/common/get_goods_info/by_barcode_page`,
        name: "QUERY_GOODS_BY_BARCODE_PAGE",
        params
      });
    },
    submitFullDelivery({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/create_delivery_rule`,
        name: "SUBMIT_FULL_DELIVERY",
        params
      });
    },
    submitFullDeliveryOverLay({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/create_delivery_rule/overlay`,
        name: "SUBMIT_FULL_DELIVERY_OVERLAY",
        params
      });
    },
    submitCombinationRule({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/create_combination_rule`,
        name: "SUBMIT_COMBINATION_RULE",
        params
      });
    },
    editSubmitCombinationRule({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/edit_combination_price`,
        name: "EDIT_SUBMIT_COMBINATION_RULE",
        params
      });
    },
    submitFullDiscount({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/create_discount_rule`,
        name: "SUBMIT_FULL_DISCOUNT",
        params
      });
    },
    submitIncreaseRule({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/create_increase_rule`,
        name: "SUBMIT_INCREASE_RULE",
        params
      });
    },
    submitSpecialRule({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/create_special_rule`,
        name: "SUBMIT_SPECIAL_RULE",
        params
      });
    },
    editSubmitIncreaseRule({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/edit_increase_purchase`,
        name: "EDIT_SUBMIT_INCREASE_RULE",
        params
      });
    },
    submitFullReduction({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/create_reduction_rule`,
        name: "SUBMIT_FULL_REDUCTION",
        params
      });
    },
    editSubmitFullReduction({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/edit_full_reduction`,
        name: "EDIT_SUBMIT_FULL_REDUCTION",
        params
      });
    },
    editSubmitFullDiscount({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/edit_full_discount`,
        name: "EDIT_SUBMIT_FULL_DISCOUNT",
        params
      });
    },
    editSubmitFullDelivery({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/edit_full_delivery`,
        name: "EDIT_SUBMIT_FULL_DELIVERY",
        params
      });
    },
    editSubmitFullDeliveryOverlay({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/edit_full_delivery/overlay`,
        name: "EDIT_SUBMIT_FULL_DELIVERY_OVERLAY",
        params
      });
    },
    modifyActivityInfoData({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeActivity/update_activity`,
        name: "MODIFY_ACTIVITY_INFO_DATA",
        params
      });
    },
    addSubCouponLog({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/add_sub_couponLog`,
        name: "ADD_SUB_COUPON_LOG",
        params
      });
    },
    editSubCouponLog({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/edit_sub_couponLog`,
        name: "EDIT_SUB_COUPON_LOG",
        params
      });
    },
    deleteSubCouponLog({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/del_sub_couponLog`,
        name: "DELETE_SUB_COUPON_LOG",
        params
      });
    },
    queryCouponPackage({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/query_coupon_list`,
        name: "QUERY_COUPON_PACKAGE",
        params
      });
    },
    saveSendCouponPackage({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/save_sub_couponLog`,
        name: "SAVE_SEND_COUPON_PACKAGE",
        params
      });
    },
    querySendCouponList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/sub_couponLog_list`,
        name: "QUERY_SEND_COUPON_LIST",
        params
      });
    },
    queryAllSendCouponList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/sub_couponLog_list`,
        name: "QUERY_ALL_SEND_COUPON_LIST",
        params
      });
    },
    actBatchOperate({ commit }, params) {
      return post({
        commit,
        url: `/promotion/check/batch_operate`,
        name: "ACT_BATCH_OPERATE",
        params
      });
    },
    promotionStatInforoi({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOrderPromotionStatInfo/roi`,
        name: "PROMOTION_STAT_INFO_ROI",
        params
      });
    },
    targetTrend({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOrderPromotionStatInfo/target_trend`,
        name: "TARGET_TREND",
        params
      });
    },
    storeOrderPromotionGoodsInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOrderPromotionStatInfo/goods_info`,
        name: "DTORE_ORDER_PROMOTION_GOODS",
        params
      });
    },
    activeTrend({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOrderPromotionStatInfo/active_trend`,
        name: "ACTIVITY_TREND",
        params
      });
    },
    editAttr({ commit }, params) {
      return post({
        commit,
        url: `/promotion/check/editAttr`,
        name: "EDIT_ATTR",
        params
      });
    },
    queryStoreConfigAll({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/query_store_config`,
        name: "QUERY_STORE_CONFIG_ALL",
        params
      });
    },
    addStoreConfigAll({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/add`,
        name: "ADD_STORE_CONFIG_ALL",
        params
      });
    },
    editStoreConfigAll({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/edit`,
        name: "EDIT_STORE_CONFIG_ALL",
        params
      });
    },
    createSuperpositionGift({ commit }, params) {
      return post({
        commit,
        url: `/rule/pasSuperpositionGift/createSuperpositionGift`,
        name: "CREATE_SUPERPOSITION_GIFT",
        params
      });
    },
    querySuperpositionGift({ commit }, params) {
      return post({
        commit,
        url: `/rule/pasSuperpositionGift/querySuperpositionGift`,
        name: "QUERY_SUPERPOSITION_GIFT",
        params
      });
    },
    editSuperpositionGift({ commit }, params) {
      return post({
        commit,
        url: `/rule/pasSuperpositionGift/editSuperpositionGift`,
        name: "EDIT_SUPERPOSITION_GIFT",
        params
      });
    },
    querySelectableRelationPromotionList({ commit }, params) {
      return post({
        commit,
        url: `/rule/pasSuperpositionGift/querySelectableRelationPromotionList`,
        name: "QUERY_SELECTABLE_RELATION_PROMOTION_LIST",
        params
      });
    },    
  }
};

export default activity;
